﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as api from "~base/Services/API";
import * as accountModel from "./Model";
//-------------------------------------------------------------------------------------
// Constants
//-------------------------------------------------------------------------------------

const uri = "api/account/v1/users/confirm";
const method = "POST";

//-------------------------------------------------------------------------------------
// Types
//-------------------------------------------------------------------------------------

interface PostConfirmProps extends api.ApiHookBaseProps<
    accountModel.PostConfirmRequest,
    unknown,
    unknown
> {}

//-------------------------------------------------------------------------------------
// API Hook
//-------------------------------------------------------------------------------------

export function useAccountPostConfirm(
    props: PostConfirmProps
): [boolean, (data: accountModel.PostConfirmRequest) => Promise<unknown>] {
    const apiParams: api.ApiHookProps<
        accountModel.PostConfirmRequest,
        unknown,
        unknown
    > = {
        ...props,
        uri: uri,
        method: method,
        skipResponseParsing: true,
    };

    const [loading, invoker] = api.useApi<
        accountModel.PostConfirmRequest,
        unknown,
        unknown
    >(apiParams);
    return [loading, (data) => invoker(apiParams.uri, data)];
}
